import { render } from "./QuestionareLink.vue?vue&type=template&id=5336ebe6&scoped=true"
import script from "./QuestionareLink.vue?vue&type=script&lang=js"
export * from "./QuestionareLink.vue?vue&type=script&lang=js"

import "./QuestionareLink.vue?vue&type=style&index=0&id=5336ebe6&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5336ebe6"]])

export default __exports__